"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageRegisterRecipe = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireDefault(require("react"));
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _DmsTabber = require("../../components/DmsTabber/DmsTabber");
var _DmsRecipeTable = require("../../components/DmsRecipe/DmsRecipeTable");
var _material = require("@mui/material");
var _DmsPartRecipeTable = require("../../components/DmsPartRecipe/DmsPartRecipeTable");
var _DmsRecipeParameterTable = require("../../components/DmsRecipeParameter/DmsRecipeParameterTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageRegisterRecipe component renders the recipe components, include DmsRecipeTable, DmsPartRecipe,
 * DmsRecipeParameterTable and DmsRecipeParameterValueTable.
 * Renders a DmsPage layout with a DmsAltBox containing the DmsProductionOrderTable component.
 * @component
 * @example
 * return (
 *   <DmsPageRegisterRecipe />
 * )
 */

const DmsPageRegisterRecipe = () => {
  const tabs = [{
    title: _reactIntlUniversal.default.get("Recipe").d("Recipe"),
    component: /*#__PURE__*/_react.default.createElement(_DmsRecipeTable.DmsRecipeTable, null)
  }, {
    title: _reactIntlUniversal.default.get("RecipePart").d("Recipe part"),
    component: /*#__PURE__*/_react.default.createElement(_DmsPartRecipeTable.DmsPartRecipeTable, null)
  }, {
    title: _reactIntlUniversal.default.get("RecipeParameter").d("Recipe parameter"),
    component: /*#__PURE__*/_react.default.createElement(_DmsRecipeParameterTable.DmsRecipeParameterTable, null)
  }];
  return /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Recipe").d("Recipe"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsTabber.DmsTabber, {
    tabs: tabs
  })));
};
exports.DmsPageRegisterRecipe = DmsPageRegisterRecipe;